
import React from 'react';
import { IncomeBreakdown } from './sections/IncomeBreakdown';
import { AssetBreakdown } from './sections/AssetBreakdown';
import { TotalContribution } from './sections/TotalContribution';

interface ContributionBreakdownProps {
  results: any;
  formData: any;
}

export function ContributionBreakdown({ results, formData }: ContributionBreakdownProps) {
  const isUsingLoan = formData.useLoan;
  const hasNursingHomeCost = formData.nursingHomeCost > 0;
  
  // Calculate actual weekly payment if using the loan
  const weeklyPaymentWithLoan = isUsingLoan 
    ? results.weeklyContribution - results.deferredAmount 
    : results.weeklyContribution;
  
  // Ensure contribution doesn't exceed nursing home cost
  const actualWeeklyPayment = hasNursingHomeCost 
    ? Math.min(weeklyPaymentWithLoan, formData.nursingHomeCost) 
    : weeklyPaymentWithLoan;

  return (
    <div className="space-y-6">
      <IncomeBreakdown results={results} formData={formData} />
      <AssetBreakdown 
        results={results} 
        formData={formData} 
        isUsingLoan={isUsingLoan}
      />
      <TotalContribution 
        results={results} 
        formData={formData}
        weeklyPaymentWithLoan={weeklyPaymentWithLoan}
        actualWeeklyPayment={actualWeeklyPayment}
        hasNursingHomeCost={hasNursingHomeCost}
        isUsingLoan={isUsingLoan}
      />
    </div>
  );
}
